import { render } from "./NavBar.vue?vue&type=template&id=b21e98f0&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=b21e98f0&lang=less&scoped=true"

import exportComponent from "D:\\case\\追溯平台\\eshop-vant4-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b21e98f0"]])

export default __exports__